export const aciMorning = {
    iconName: 'morning',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 22 22' },
        path: [
            {
                attr: {
                    d: 'M11 1.625v.625M17.892 4.108l-.704.705M20.375 11h-.625M17.63 17.63l-.442-.442M11 20.375v-.625M4.37 17.63l.443-.442M1.625 11h.625M4.37 4.37l.443.442',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M11 17.875a6.875 6.875 0 100-13.75 6.875 6.875 0 000 13.75z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
